module.exports = __webpack_public_path__ + "static/media/PlanPagos.35059cbe.jpg";